module.exports = __webpack_public_path__ + "static/media/m_beard_stubble_v_red.709d4a84.png";